// extracted by mini-css-extract-plugin
export var tosLink = "_9h-0";